import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  payment: {
    interpreterPayment: [],
    vendorPayment: [],
  },
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: initialState,
  reducers: {
    setInterpreterPayment: (state, { payload }) => {
      state.payment.interpreterPayment = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setInterpreterPayments: (state, { payload }) => {
      state.payment.interpreterPayment = payload?.data ?? payload; // Ensure payload structure
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setVendorPayment: (state, { payload }) => {
      state.payment.vendorPayment = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setVendorPayments: (state, { payload }) => {
      state.payment.vendorPayment = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMorePayments: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removePayment: (state, { payload }) => {
      state.error = payload
    },
    clearAllPayment: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchInterpreterPayments = (page, params, disableLoader, Aync, callback) => async (dispatch) => {
  // !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchAdminInterpreterPayments(page, params)
    if (result.status >= 200 && result.status < 300) {
      callback(result.data?.data)
      // dispatch(setInterpreterPayments(result.data))
      // !disableLoader && dispatch(setLoader(false))
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        callback({data:[]})
        dispatch(setError(result.data))
        // !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    callback({data:[]})
    console.log("error", error)
  }
}
export const fetchVendorPayments = (page, params, disableLoader, Aync, callback) => async (dispatch) => {
  // !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchAdminVendorPayments(page, params)
    if (result.status >= 200 && result.status < 300) {
      callback(result.data?.data)
      // dispatch(setInterpreterPayments(result.data))
      // !disableLoader && dispatch(setLoader(false))
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        callback({data:[]})
        dispatch(setError(result.data))
        // !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    callback({data:[]})
    console.log("error", error)
  }
}
// export const fetchVendorPayments = (page, params, disableLoader, Aync) => async (dispatch) => {
//   !disableLoader && dispatch(setLoader(true))
//   try {

//     const result = await Api.fetchAdminVendorPayments(page, params)
//     if (result.status >= 200 && result.status < 300) {
//       if (page > 1) {
//         if (Aync) {
//           return result?.data?.data;
//         } else {
//           dispatch(setVendorPayments(result.data.data));
//           !disableLoader && dispatch(setLoader(false))
//         }
//       } else {
//         if (Aync) {
//           return result?.data?.data;
//         } else {
//           dispatch(setVendorPayments(result.data.data));
//           !disableLoader && dispatch(setLoader(false))
//         }
//       }
//     }
//     else if (result?.status == 422) {
//       if (Aync) {
//         return [];
//       } else {
//         dispatch(setError(result.data))
//         !disableLoader && dispatch(setLoader(false))
//       }
//     }
//   } catch (error) {
//     console.log("error", error)
//   }
// }



export const handleMultipleStatus = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.handleMultipleStatus(ids)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false))
}

export const { setInterpreterPayment, setInterpreterPayments, setVendorPayment, setVendorPayments, clearAllPayment, setLoader, setError, setMorePayments } = paymentSlice.actions


export default paymentSlice.reducer
export const paymentSelector = state => state.payment


